<template>
  <div>
    <Card>
      <Row class="search-con">
        <Col span="20">
          <label class="search-label">付款开始时间</label>
          <Date-picker
            :value="startTime"
            @on-change="startTime = $event"
            type="datetime"
            placeholder="选择开始时间"
            style="width: 170px"
          ></Date-picker>
          <label class="search-label">付款结束时间</label>
          <Date-picker
            :value="endTime"
            @on-change="endTime = $event"
            type="datetime"
            placeholder="选择结束时间"
            style="width: 170px"
          ></Date-picker>
          <Button @click="handleSearch" class="search-btn" type="primary"
            >搜索</Button
          >
        </Col>
        <Col span="4">
          <label >总金额:{{ allMoney }}</label>
        </Col>
      </Row>
      <tables
        editable
        :columns="columns"
        v-model="tableData"
        :loading="tableLoading"
      />
      <Row class="page-con">
        <div class="page-bottom">
          <Page
            :current="page"
            :total="total"
            :page-size="pageSize"
            show-sizer
            show-elevator
            @on-change="changePage"
            @on-page-size-change="changePageSize"
          />
        </div>
      </Row>
    </Card>
  </div>
</template>

<script>
import Tables from "_c/tables/table-only.vue";
import { getShipmentList, delShipment, exportShipment, exportSettlement, editShipmentPayStatus } from "@/api/data";
export default {
  name: "finance",
  components: {
    Tables,
  },
  data() {
    return {
      page: 1,
      total: 0,
      pageSize: 10,

      addModal: false,
      editModal: false,
      resetFlag: false,
      editData: {},
      tableLoading: true,
      allMoney: 0.0,
      startTime: "",
      endTime: "",
      columns: [
        {
          type: "selection",
          width: 60,
          align: "center",
        },
        { title: "订单编号", width: 200, key: "order_no", editable: true },
        { title: "客户", width: 150, key: "customer", editable: true },
        {
          title: "类型",
          key: "type",
          render: (h, params) => {
            let texts = "";
            if (params.row.type == 0) {
              texts = "验布类";
            } else if (params.row.type == 1) {
              texts = "包装类";
            }
            return h(
              "div",
              {
                props: {},
              },
              texts
            );
          },
        },
        { title: "匹数", key: "count", editable: true },
        { title: "单价", key: "unitPrice", editable: true },
        { title: "码长", key: "code", editable: true },
        { title: "总金额", key: "money", editable: true },
        {
          title: "付款状态",
          key: "type",
          render: (h, params) => {
            let texts = "";
            if (params.row.status == 0) {
              texts = "未付款";
            } else if (params.row.status == 1) {
              texts = "已付款";
            }
            return h(
              "div",
              {
                props: {},
              },
              texts
            );
          },
        },
        { title: "付款时间", key: "pay_time", editable: true },
        {
          title: "Handle",
          key: "handle",
          render: (h, params) => {
            return h("div", [
              h(
                "Dropdown",
                {
                  props: {
                    transfer: true,
                  },
                },
                [
                  h(
                    "Button",
                    {
                      props: {
                        type: "text",
                        size: "small",
                      },
                    },
                    "更多"
                  ),
                  h(
                    "DropdownMenu",
                    {
                      slot: "list",
                    },
                    [
                      h(
                          "DropdownItem",
                          {
                              props: {
                                  disabled: params.row.status === 1
                              },
                              nativeOn: {
                                  click: (name) => {
                                      this.checkPayStatus(params)
                                  },
                              }
                          },
                          "确认付款"
                      ),
                      h(
                        "DropdownItem",
                        {
                          nativeOn: {
                            click: (name) => {
                              this.downloadShipment(params);
                            },
                          },
                        },
                        "下载出货单"
                      ),
                      h(
                        "DropdownItem",
                        {
                          nativeOn: {
                            click: (name) => {
                              this.downloadSettlement(params);
                            },
                          },
                        },
                        "下载结算单"
                      ),
                    ]
                  ),
                ]
              ),
              h(
                "Button",
                {
                  props: {
                    type: "text",
                    size: "small",
                  },
                  style: {
                    marginRight: "5px",
                  },
                  on: {
                    click: () => {
                      this.handleDelete(params);
                    },
                  },
                },
                "删除"
              ),
            ]);
          },
        },
      ],
      tableData: [],
    };
  },
  methods: {
    downloadShipment(params) {
        exportShipment(params.row.id).then(res => {
            if (res.data.code == 200) {
                window.setTimeout(function () {
                    if (process.env.NODE_ENV === 'production') {
                    window.open('https://bu.sinano-ai.com/' + res.data.data)
                    } else {
                    window.open("https://bu.sinano-ai.com/" + res.data.data)
                    }
                }, 2000)
            }
        })
    },
    downloadSettlement(params) {
        exportSettlement(params.row.id).then(res => {
            if (res.data.code == 200) {
                window.setTimeout(function () {
                    if (process.env.NODE_ENV === 'production') {
                    window.open('https://bu.sinano-ai.com/' + res.data.data)
                    } else {
                    window.open("https://bu.sinano-ai.com/" + res.data.data)
                    }
                }, 2000)
            }
        })
    },
    checkPayStatus(params) {
        if (params.row.status == 1) {
            return
        }
        this.$Modal.confirm({
            title: '提示',
            content: '<p>是否确认付款？</p><p>确认付款后无法撤销</p>',
            onOk: () => {
                editShipmentPayStatus(params.row.id).then(res => {
                    if (res.data.code == 200) {
                        this.$Message.info('付款成功');
                        this.handleSearch()
                    }
                })
            },
            onCancel: () => {
                this.$Message.info('已取消');
            }
        });
    },
    showAddModal() {
      this.addModal = true;
      this.resetFlag = !this.resetFlag;
    },
    showEditModal(params) {
      this.editData = params.row;
      this.editModal = true;
    },
    addSumit(formValidate) {
      let data = new FormData();
      data.set("desc", formValidate.desc);
      addRemark(data)
        .then((res) => {
          // res
          // data {code data msg}
          // status
          if (res.data.code == 200) {
            this.$Message.success("成功!");
            this.addModal = false;
            this.handleSearch();
          } else {
            this.$Message.error(res.data.msg);
          }
        })
        .catch((err) => {
          this.$Message.error("失败!");
        });
    },
    editSumit(formValidate) {
      let data = new FormData();
      data.set("desc", formValidate.desc);
      editRemark(data, formValidate.id)
        .then((res) => {
          if (res.data.code == 200) {
            this.$Message.success("成功!");
            this.editModal = false;
            this.handleSearch();
          } else {
            this.$Message.error(res.data.msg);
          }
        })
        .catch((err) => {
          this.$Message.error("失败!");
        });
    },
    cancel() {},
    changePage(page) {
      this.page = page;
      this.handleSearch();
    },
    changePageSize(pageSize) {
      this.pageSize = pageSize;
      this.handleSearch();
    },
    handleSearch() {
      this.setTableLoading(true);
      console.log(this.startTime)
      let params = {
        page: this.page,
        pageSize: this.pageSize,
        payStartTime: this.startTime,
        payEndTime: this.endTime,
      };
      getShipmentList(params).then((res) => {
        if (res.data.code == 200) {
          this.allMoney = res.data.data.allMoney
          this.tableData = res.data.data.list.records;
          this.total = res.data.data.list.total;
          console.log(this.total);
        } else {
          this.tableData = [];
          this.total = 0;
        }
        this.setTableLoading(false);
      });
    },
    handleDelete(params) {
        this.$Modal.confirm({
            title: '提示',
            content: '<p>是否确认删除？</p>',
            onOk: () => {
                 delShipment(params.row.id)
                .then((res) => {
                    if (res.data.code == 200) {
                        this.tableData.splice(params.index, 1);
                        this.$Message.success("成功!");
                    } else {
                        this.$Message.error(res.data.msg);
                    }
                }).catch((err) => {
                    this.$Message.error("失败!");
                });
            },
            onCancel: () => {
                this.$Message.info('已取消');
            }
        });
    },
    setTableLoading(state) {
      this.tableLoading = state;
    },
  },
  mounted() {
    this.handleSearch();
  },
};
</script>
